import slugify from 'slugify'

const joinString = (value = '') => {
  return slugify(value, {
    replacement: '.',
    lower: true,
  })
}

const shouldAddBrokerFakeEmail = (data, country) => {
  if (!data.email) {
    const { firstName, lastName, companyName } = { ...data }
    const usernameEmail = `${joinString(firstName)}.${joinString(lastName)}`
    const domainEmail = joinString(companyName)
    return {
      ...data,
      email: `${usernameEmail}+broker@${domainEmail}.com.${country}`,
    }
  }

  return data
}

export default shouldAddBrokerFakeEmail
